import React from 'react';

export interface ContainerProps {
  children: React.ReactNode;
  className?: string;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'full' | 'none';
  padding?: boolean;
  centered?: boolean;
}

/**
 * Container component for layout control
 * Provides consistent maximum widths and padding
 */
const Container: React.FC<ContainerProps> = ({
  children,
  className = '',
  maxWidth = 'lg',
  padding = true,
  centered = true,
}) => {
  // Max width classes
  const maxWidthClasses = {
    xs: 'max-w-xs',
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    full: 'max-w-full',
    none: '',
  };

  return (
    <div
      className={`
        ${maxWidth !== 'none' ? maxWidthClasses[maxWidth] : ''}
        ${padding ? 'px-4 py-6 md:px-6' : ''}
        ${centered ? 'mx-auto' : ''}
        w-full
        ${className}
      `}
    >
      {children}
    </div>
  );
};

export default Container;